import { useEffect, useState } from 'react'
import constant from '../../constant'
import { getSessionStorage, setSessionStorage } from '../../utils'
import { v3_profile_detail } from '../../actions/v3/user'
import { useGlobalData } from '../../context/GlobalDataContext'

const ProfileCard = () => {
    const [ud, set_ud] = useState({})
    const { globalData } = useGlobalData();

    useEffect(() => {
        if (getSessionStorage(constant.keys.userDetails)) {
            set_ud(JSON.parse(atob(getSessionStorage(constant.keys.userDetails))))
        }
        else {

            v3_profile_detail().then((res) => {
                if (res.status) {
                    set_ud(JSON.parse(atob(res.result)))
                    setSessionStorage(constant.keys.userDetails, res.result)

                }
            })
        }

    }, [])
    return (
        <div className="card overflow-hidden">
            <div
                className=""
                style={{ backgroundColor: "rgb(204 202 202 / 50%)" }}
            >
                <div className="row">
                    <div className="col-7">
                        <div className="text-primary p-3">
                            <h5
                                // className="text-primary"
                                style={{ color: "#2c587a" }}
                            >
                                Welcome Back !
                            </h5>
                            <p style={{ color: "#333" }}>
                                NEW-BUILD Ship Management
                            </p>
                        </div>
                    </div>
                    <div className="col-5 align-self-end d-flex justify-content-end">
                        <img
                            src={`img/ship-cargo.png?id=${Math.random()}`}
                            alt="Ship Cargo"
                            style={{ maxWidth: "70%", marginRight: "15px" }}
                            className="img-fluid"
                        />
                    </div>
                </div>
            </div>
            <div className="card-body pt-0">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="avatar-md profile-user-wid mb-4">
                            <img
                                src={ud.profileImageUrl
                                    ? process.env.REACT_APP_BASE_URL + ud.profileImageUrl
                                    : `${process.env.REACT_APP_BASE_URL}/v1/globalSettings/${globalData?.DEFAULT_PROFILE_PIC}`}
                                alt=""
                                className="img-thumbnail rounded-circle"
                            />
                        </div>
                        <h5 className="font-size-15 text-truncate">{ud.fullName}</h5>
                        <p className="text-muted mb-0 text-truncate">{ud.ROLE_NAME}</p>
                    </div>
                    <div className="col-sm-8">
                        <div className="pt-4">
                            <div className="row">
                                <div className="col-6">
                                    <h5 className="font-size-15">&nbsp;</h5>
                                    <p className="text-muted mb-0">&nbsp;</p>
                                </div>
                                <div className="col-6">
                                    <h5 className="font-size-15">&nbsp;</h5>
                                    <p className="text-muted mb-0">&nbsp;</p>
                                </div>
                            </div>
                            <div className="mt-4">
                                <a
                                    href={constant.Authedcomponent.updateProfile.url}
                                    className="btn btn-primary waves-effect waves-light btn-sm"
                                    style={{
                                        backgroundImage:
                                            "linear-gradient(90deg, #6996b5, #2b5a7e)"
                                    }}
                                >
                                    View Profile <i className="mdi mdi-arrow-right ms-1" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileCard